const allColors = [
    [

        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#00D9A5",
    ],
    [

        "#3347B0",
        "#E8B4E7",
        "#CCF6E8",
    ],
    [

        "#ffbf6e",
        "#a6d40d",
        "#651300",
    ],
    [

        "#0024cc",
        "#ffbf6e",
        "#9c52f2",
    ],
    [

        "#00d973",
        "#fa2b00",
        "#0000ff",
    ],
    [

        "#fefcfb",
        "#2969ee",
        "#01886A",
    ],
    [

        "#0000ff",
    ],
    [

        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
    ],
    [

        "#8c6510",
        "#ffb852",
    ],
    [

        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#7A999C",
        "#475B62",
    ],
    [

        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [

        "#0000ff",
        "#2619d1",
        "#2969ee",
        "#efcc7c",
    ],
    [

        "#3BB487",
        "#E6393B",
        "#EC6DA4",
        "#777CBC",
    ],
    [

        "#6D262A",
        "#C6422B",
        "#00A86D",
        "#024633",
        "#038DB2",
        "#CA1D2A",
    ],

    [

        "#888",
        "#aaa",
        "#bbb",
        "#ddd",
    ],
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#FFFFFF",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ],
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#FFFFFF",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ],
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ],
    [
        "#131F1D",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#D6D9DB",
        "#00D9A5",
    ],
    [
        "#131F1D",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#D6D9DB",
        "#00D9A5",
    ],
    [
        "#131F1D",
        "#3347B0",
        "#E8B4E7",
        "#CCF6E8",
    ],
    [

        "#9c52f2",
        "#b85e00",
        "#9c52f2",
        "#730f1f",
        "#9c52f2",
    ],
    [

        "#9c52f2",
        "#ffbf6e",
        "#0024cc",
        "#9c52f2",
    ],
    [

        "#0024cc",
        "#ffbf6e",
        "#9c52f2",
    ],
    [

        "#0024cc",
        "#ffbf6e",
        "#9c52f2",
    ],
    [

        "#ffbf6e",
        "#a6d40d",
        "#651300",
    ],
    [
        "#000831",
        "#00d973",
        "#fa2b00",
        "#0000ff",
    ],
    [
        "#3400a3",
        "#d50c42",
        "#19cc33",
    ],
    [
        "#111111",
        "#fefcfb",
        "#d50c42",
    ],
    [
        "#0000ff",
        "#ffffff",
    ],
    [

        "#ff5ec4",
        "#a93400",
        "#1b8e13",
    ],
    [
        "#00592e",
        "#ffffff",
        "#ff0000",
        "#ffff00",
        "#0E8DD2",
    ],
    [
        "#0f261f",
        "#ffab00",
        "#bfabcc",
        "#00ff00",
    ],
    [
        "#0f261f",
        "#faed8f",
        "#e62e73",
        "#0E8DD2",
    ],
    [
        "#06004f",
        "#cc1a97",
        "#9161f2",
        "#2619d1",
        "#ffb852",
        "#fa3219",
        '#00ff00'
    ],
    [
        "#172713",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#2619d1",
    ],
    [
        "#172713",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
    ],
    [
        "#172713",
        "#00592e",
        "#d50c42",
        "#ff7399",
        "#00592e",
        "#d50c42",
        "#ff7399",
        "#FABF01",
    ],
    [
        "#172713",
        "#8c6510",
        "#ffb852",
        "#ffa6d9",
    ],
    [
        "#172713",
        "#328e13",
        "#ff616b",
        "#a6e6db",
    ],
    [
        "#10120F",
        "#F44A0F",
        "#0E8DD2",
        // "#10971F",
        "#5AA316",
        "#E53F0F",
    ],
    [
        "#1f1816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#14a160",
        "#f9cd22",
        "#14a160",
        "#14a160",
    ],
    [

        "#f1594a",
        "#14a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#0609b1",
        "#ebd999",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [

        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [

        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [

        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#06004f",
        "#202d85",
        "#f2ff26",
        "#bdf226",
        "#d50c42",
        "#9161f2",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#bdf226",

        "#efcc7c",
    ],
    [
        "#2619d1",
        "#2969ee",
        "#bdf226",
        "#efcc7c",
    ],
    [
        "#2619d1",
        "#2969ee",
        "#d50c42",

        "#efcc7c",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],


    [
        '#777',
        '#ddd',
        '#fff',
        '#777',
        '#ddd',
        '#fff',
    ],
    [
        '#114ff2',
        '#114ff2',
        '#114ff2',
        '#d91c2f',
        '#d91c2f',
        '#fe3da7',
        '#fe3da7',
        '#f79357',
        '#f79357',
        '#fbc442',
        '#fbc442',
        '#114ff2',
        '#5f317d',
        '#5f317d',
        '#bb39a2',
        '#bb39a2',
        '#f45969',
        '#f45969',
        '#fbc442',
    ],
    [
        '#377D71',
        '#8879B0',
        '#FBA1A1',
        '#FBC5C5',
        '#214942',
        '#704723',
        '#6dad9f',
        '#6dad9f',
        '#f99d9d',
        '#f8b861',
    ],
    [
        '#29264E',
        '#9881F5',
        '#F97D81',
        '#fcbcbe',
        '#f7c066',
        '#354e6f',
        '#8475bd',
        '#6daba5',
        '#fcbcde',
        '#f7c066',
    ],
    [
        '#4a69fe',
        '#226330',
        '#ef412f',
        '#efac25',
        '#eeefd0',
        '#6b8adc',
        '#226330',
        '#c4685b',
        '#c1a953',
        '#eeefd0',
    ],
    [
        '#0C282D',
        '#0C282D',
        '#2B4039',
        '#9A422E',
        '#d87d1b',
        '#DFB4BF',
        '#2B4039',
        '#9A422E',
        '#d87d1b',
        '#DFB4BF',
    ]

]

export default allColors